import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { ErrorContext } from 'in-meeting-experience-ui-components/contexts/error/context';
import { useContext } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { routes } from '../../constants/routes';
import OutsideMeeting from '../../containers/OutsideMeeting';
import Portal from '../../containers/Portal';
import useGoogleMeeting from '../../hooks/useGoogleMeeting';
import usePortalNavigate from '../../hooks/usePortalNavigate';
import usePortalUserInfo from '../../hooks/usePortalUserInfo';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function UserRoutes() {
  const {
    path
  } = useRouteMatch();
  const {
    isExternalOutage
  } = useContext(ErrorContext);
  const isPortalUserInfoLoading = usePortalUserInfo();
  const isGoogleMeetingLoading = useGoogleMeeting();
  usePortalNavigate();
  if ((isPortalUserInfoLoading || isGoogleMeetingLoading) && !isExternalOutage) return /*#__PURE__*/_jsx(LoadingOverlay, {});
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: `${path}${routes.outsideMeeting}`,
      component: OutsideMeeting
    }), /*#__PURE__*/_jsx(Route, {
      path: path,
      component: Portal
    })]
  });
}